<template>
  <div class="block paragraph" :class="{ odd }">
    <div class="body" v-html="body" />
  </div>
</template>

<script>
  export default {
    name: 'BlockParagraph',
    components: {
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      content: {
        type: Object,
        default: null,
      },
      odd: {
        type: Boolean,
        default: false,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      body() {
        let body = this.content?.body || null;
        if (body) {
          body = this.parsePossibleTimeline(body);
        }

        const file = (this.content?.file || [])[0] || null;
        let label = this.content?.fileTitle || null;
        if (file && file.path) {
          const url = `${this.$b.contentUrl}/${file.path}`;
          label = label || file.path.split('/').pop();
          body += `<a class="btn" href="${url}" target="blank">${label}</a>`;
        }

        return body || null;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      parsePossibleTimeline(htmlString) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;

        const divs = Array.from(tempDiv.children).filter(child => child.tagName === 'DIV');
        const transformedDivs = [];
        const regex = /^(?:<strong>\s*)?(\d{4}(?: ?[-– ] ?\d{4})?)(?:\s*<\/strong>)?\t+(.*)$/s;

        for (let i = 0; i < divs.length; i += 1) {
          const div = divs[i];
          const content = div.innerHTML.trim();
          const match = content.match(regex);
          if (match) {
            const year = match[1];
            const restOfContent = match[2];
            const hasTwoYears = /[-– ]/.test(year);

            const yearRefDiv = document.createElement('div');
            yearRefDiv.classList.add('year-ref', hasTwoYears ? 'two-years' : 'one-year');

            const yearDiv = document.createElement('div');
            yearDiv.innerHTML = `<strong>${year}</strong>`;

            const contentDiv = document.createElement('div');
            contentDiv.innerHTML = restOfContent;

            yearRefDiv.appendChild(yearDiv);
            yearRefDiv.appendChild(contentDiv);
            transformedDivs.push(yearRefDiv);
          } else {
            transformedDivs.push(div.cloneNode(true));
          }
        }

        let resultHtml = '';
        transformedDivs.forEach((node) => { resultHtml += node.outerHTML; });

        return resultHtml;
      },
      //----------------------------------
      // Event Handlers
      //----------------------------------
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.block.paragraph {
  display: flex;
  justify-content: center;

  @include screen-mobile {
    width: calc(100% + 4px);
  }

  & > .body {
    max-width: 950px;
    width: 100%;
    margin-bottom: 60px;

    @include screen-mobile {
      min-width: 100%;
    }

    p {
      margin: 20px 0;
      &:first-of-type { margin-top: 0; }
      &:last-of-type { margin-bottom: 0 }
    }

    & > a.btn {
      display: inline-block;
      color: inherit;
      text-decoration: none;
      margin-top: 20px;
      background-color: white;
      padding: 10px 20px;
      font-family: inherit;
      border: 1px solid black;
      font-size: inherit;
      font-weight: 400;
      outline: 0;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

      &:focus-within, &:hover {
        outline: 1px solid black;
        box-shadow: 0 3px 4px rgba(0, 0, 0, 0.4);
      }
    }

    & > div.year-ref {
      display: flex;
      margin-bottom: 2px;
      gap: 32px;

      &.two-years > div:first-child {
        min-width: 102px;
      }

      &.one-year > div:first-child {
        min-width: 50px;
      }

      @include screen-mobile {
        gap: 20px;

        & > div:nth-child(1) {
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
